<template>
  <div>
    <a-layout class="main-layout">
      <!-- 顶部导航栏 -->
      <a-layout-header class="main-layout-header">
        <div class="logo">
          <img :src="require('../assets/images/ipipbright.png')" alt="IpipBright logo" :style="{ height: '55px', width: 'auto', objectFit: 'contain' }">
        </div>
        <a-menu
          theme="dark"
          mode="horizontal"
          :selected-keys="[activeMenu]"
          :open-keys="openKeys"
          @openChange="handleOpenChange"
          @select="handleMenuSelect"
          :style="{ background: '#1a1f35', borderBottom: 0 }"
        >
          <!-- 控制面板主菜单 -->
          <a-sub-menu key="dashboard">
            <span slot="title">
              <a-icon type="dashboard" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.auth }}</span>
              <!-- 添加下箭头 -->
               <a-icon type="caret-down" theme="filled" :style="{ fontSize: '16px', marginLeft: '10px' }"  />
            </span>
            <!-- 子菜单 -->
          <a-menu-item key="base">
            <a-icon type="home" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.auth }}</span>
          </a-menu-item>
          <a-menu-item key="sub-account">
            <a-icon type="user" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.subAccount }}</span>
          </a-menu-item>
          <a-menu-item key="traffic">
            <a-icon type="line-chart" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.traffic }}</span>
          </a-menu-item>
          <a-menu-item key="login-record">
            <a-icon type="clock-circle" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.loginRecord }}</span>
          </a-menu-item>
          <a-menu-item key="flow-record">
            <a-icon type="wallet" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.flowRecord }}</span>
          </a-menu-item>
        </a-sub-menu>
        
        <!-- 购买大菜单 -->
        <!-- <a-sub-menu key="purchase">
          <span slot="title">
              <a-icon type="shopping-cart" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.dynamicResidential }}</span>
            </span>
          <a-menu-item key="purchase">
            <a-icon type="credit-card" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.buyPlan }}</span>
          </a-menu-item>
        </a-sub-menu> -->
        
        <!-- 静态住宅大菜单 -->
        <!-- <a-sub-menu key="staticnux">
          <span slot="title">
              <a-icon type="home" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.staticResidential }}</span>
            </span>
          <a-menu-item key="staticnux">
            <a-icon type="file-text" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.staticResidential }}</span>
          </a-menu-item>
          <a-menu-item key="staticnux-purchase">
            <a-icon type="shopping-cart" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.staticResidentialNative }}</span>
          </a-menu-item>
          <a-menu-item key="staticnux-broadcast-purchase">
            <a-icon type="shopping-cart" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.staticResidentialBroadcast }}</span>
          </a-menu-item>
        </a-sub-menu> -->
        
        <!-- 工具大菜单 -->
        <a-sub-menu key="utiltools">
          <span slot="title">
              <a-icon type="tool" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.tools }}</span>
              <a-icon type="caret-down" theme="filled" :style="{ fontSize: '16px', marginLeft: '10px' }"  />
            </span>
          <a-menu-item key="utiltools-qrcode">
            <a-icon type="qrcode" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.qrcodeGenerator }}</span>
          </a-menu-item>
          <a-menu-item key="utiltools-proxy-tester">
            <a-icon type="appstore" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.proxyTester }}</span>
          </a-menu-item>
        </a-sub-menu>
        
        <!-- API文档大菜单 -->
        <!-- <a-sub-menu key="api-docs">
          <span slot="title">
              <a-icon type="book" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.apiDocs }}</span>
            </span>
          <a-menu-item key="api-docs-dynamic">
            <a-icon type="api" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.dynamicApi }}</span>
          </a-menu-item>
          <a-menu-item key="api-docs-static">
            <a-icon type="file-done" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.staticApi }}</span>
          </a-menu-item>
        </a-sub-menu> -->
        
        <!-- 个人中心大菜单 -->
        <a-sub-menu key="user">
          <span slot="title">
              <a-icon type="user" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.userCenter }}</span>
              <a-icon type="caret-down" theme="filled" :style="{ fontSize: '16px', marginLeft: '10px' }"  />
            </span>
          <a-menu-item key="settings">
            <a-icon type="setting" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.userSettings }}</span>
          </a-menu-item>
        </a-sub-menu>
        </a-menu>
        
        <!-- 右侧导航 -->
        <div class="header-right">
            <!-- 语言切换 -->
            <a-dropdown>
              <div class="language-switch">
                <a-icon type="global" :style="{ fontSize: '16px' }" />
                <span class="language-text">{{ currentLanguage }}</span>
                <a-icon type="caret-down" theme="filled" :style="{ fontSize: '16px', marginLeft: '10px' }"  />
              </div>
              <a-menu slot="overlay" @click="handleLanguageChange">
                <a-menu-item key="zh-CN">
                  <span>简体中文</span>
                </a-menu-item>
                <a-menu-item key="en-US">
                  <span>English</span>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            
            <!-- 登录状态显示 -->
            <template v-if="isLoggedIn">
              <a-dropdown>
              <div class="user-info">
                <a-avatar :size="32">
                  <a-icon slot="icon" type="user" />
                </a-avatar>
                <span class="username">{{ userName }}</span>
                <a-icon type="caret-down" theme="filled" :style="{ fontSize: '16px', marginLeft: '10px' }"  />
              </div>
              <a-menu slot="overlay">
                <!-- <a-menu-item @click="handleUserProfile">
                  <a-icon type="user" />
                  <span>个人资料</span>
                </a-menu-item> -->
                <a-menu-item @click="handleSettings">
                  <a-icon type="setting" />
                  <span>{{ t.personalSettings }}</span>
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item @click="handleLogout">
                  <a-icon type="logout" />
                  <span>{{ t.logout }}</span>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            </template>
          </div>
      </a-layout-header>
      
      <!-- 主内容区域 -->
      <a-layout>
        <!-- 内容区域 -->
        <a-layout-content class="main-layout-content">
          <router-view />
        </a-layout-content>
        
        <!-- 页脚 -->
        <!-- <a-layout-footer class="main-layout-footer">
          ipipbright ©2026 All Rights Reserved
        </a-layout-footer> -->
      </a-layout>
    </a-layout>
    
    <!-- 悬浮客服按钮 -->
    <div id="kefu" style="position: fixed; bottom: 40px; right: 40px; z-index: 999;">
      <label slot="reference" class="topBtn" @click="Kefu()" :title="t.customerService" style="cursor: pointer; display: flex; align-items: center; justify-content: center; width: 60px; height: 60px; border-radius: 50%; background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%); color: white; font-size: 24px; box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4); transition: all 0.3s ease;">
        <a-icon type="customer-service" />
      </label>
    </div>
    
    <!-- 客服弹窗 -->
    <a-modal
        v-model="visible"
        :title="t.customerService"
        :footer="null"
        width="600px"
        :maskClosable="true"
      >
      <div style="display: flex;align-items: center;padding: 20px 0" v-for="item in FormatList" :key="item.id">
        <div style="display: flex;align-items: center; color: #333">
          <span>{{ item.contacttype }} :</span> 
          <a class="contact-link" :href="item.link" target="_blank" rel="noopener noreferrer"> {{ item.contact }}</a>
        </div>
        <div class="QrcodeWrap" v-if="item.contacttype == 'wechat' || item.contacttype == 'qq'" style="margin-left: 20px;">
          <qrcode-vue :value="item.contact"  :size="size" level="L" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import qrcodeVue from 'qrcode-vue'
export default {
  name: 'MainLayout',
  components: {
    qrcodeVue
  },
  data() {
    return {
      openKeys: [],
      activeMenu: 'base',
      // 登录状态相关
      isLoggedIn: false,
      userName: '',
      // 语言切换相关
      currentLanguage: 'English',
      languageCode: 'en', // 用于传递给子组件的语言代码
      languageMap: {
        'zh-CN': '简体中文',
        'en-US': 'English'
      },
      // 客服相关
      visible: false,
      FormatList: [],
      size: 100,
      userId: localStorage.getItem('userId') || '',
      // 页面文本国际化配置
      i18n: {
        en: {
          // 侧边栏菜单
          auth: 'Account Auth',
          subAccount: 'Sub Accounts',
          traffic: 'Traffic Usage',
          loginRecord: 'Login Records',
          flowRecord: 'Recharge Records',
          dynamicResidential: 'Dynamic Residential',
          buyPlan: 'Buy Plan',
          staticResidential: 'Static Residential',
          staticResidentialNative: 'Static Native',
          staticResidentialBroadcast: 'Static Broadcast',
          tools: 'Tools',
          qrcodeGenerator: 'QR Code',
          proxyTester: 'Proxy Tester',
          apiDocs: 'API Docs',
          dynamicApi: 'Dynamic API',
          staticApi: 'Static API',
          userCenter: 'User Center',
          userSettings: 'Settings',
          // 顶部导航和下拉菜单
          personalSettings: 'Settings',
          logout: 'Logout',
          customerService: 'Customer Service',
          contactType: 'Contact Type'
        },
        zh: {
          // 侧边栏菜单
          auth: '账密认证',
          subAccount: '子账号管理',
          traffic: '流量使用概括',
          loginRecord: '登录记录',
          flowRecord: '流量充值记录',
          dynamicResidential: '动态住宅',
          buyPlan: '购买套餐',
          staticResidential: '静态住宅',
          staticResidentialNative: '静态住宅原生购买',
          staticResidentialBroadcast: '静态住宅广播购买',
          tools: '工具',
          qrcodeGenerator: '二维码生成',
          proxyTester: '代理测试',
          apiDocs: '接口文档',
          dynamicApi: '动态API',
          staticApi: '静态API',
          userCenter: '个人中心',
          userSettings: '个人设置',
          // 顶部导航和下拉菜单
          personalSettings: '个人设置',
          logout: '退出登录',
          customerService: '客服',
          contactType: '联系方式'
        }
      }
    };
  },
  
  // 提供语言状态给子组件
  provide() {
    return {
      languageState: this
    };
  },
  computed: {
    // 获取当前语言的文本
    t() {
      const lang = this.languageCode;
      return this.i18n[lang] || this.i18n.en;
    }
  },
  mounted() {
    // 根据当前路由设置激活的菜单项
    this.setActiveMenu();
    // 检查登录状态
    this.checkLoginStatus();
  },
  watch: {
    // 监听路由变化，更新激活的菜单项
    $route() {
      this.setActiveMenu();
      // 路由变化时重新检查登录状态
      this.checkLoginStatus();
    }
  },
  methods: {
    // 处理菜单展开/折叠
    handleOpenChange(openKeys) {
      this.openKeys = openKeys;
    },
    
    // 处理菜单选择
    handleMenuSelect({ key }) {
      this.activeMenu = key;
      
      // 根据选择的菜单项跳转到对应的路由
      let targetRoute = '';
      switch (key) {
        case 'base':
          targetRoute = '/dashboard/base';
          break;
        case 'sub-account':
          targetRoute = '/dashboard/sub-account';
          break;
        case 'traffic':
          targetRoute = '/dashboard/traffic';
          break;
        case 'login-record':
          targetRoute = '/dashboard/login-record';
          break;
        case 'flow-record':
          targetRoute = '/dashboard/flow-record';
          break;
        // case 'purchase':
        //   targetRoute = '/purchase/buy';
        //   break;
        // case 'staticnux':
        //   targetRoute = '/staticnux/index';
        //   break;
        // case 'staticnux-purchase':
        //   targetRoute = '/staticnux/purchase';
        //   break;
        // case 'staticnux-broadcast-purchase':
        //   targetRoute = '/staticnux/broadcast-purchase';
        //   break;
        case 'utiltools-qrcode':
          targetRoute = '/utiltools/qrcode';
          break;
        case 'utiltools-proxy-tester':
          targetRoute = '/utiltools/proxy-tester';
          break;
        // case 'api-docs-dynamic':
        //   targetRoute = '/api-docs/dynamic';
        //   break;
        // case 'api-docs-static':
        //   targetRoute = '/api-docs/static';
        //   break;
        case 'settings':
          targetRoute = '/user/settings';
          break;
        default:
          targetRoute = '/dashboard/base';
      }
      
      // 避免冗余导航警告
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },
    
    // 根据当前路由设置激活的菜单项
    setActiveMenu() {
      const path = this.$route.path;
      switch (path) {
        // dashboard相关路由
        case '/dashboard/base':
          this.activeMenu = 'base';
          this.openKeys = [];
          break;
        case '/dashboard/sub-account':
          this.activeMenu = 'sub-account';
          this.openKeys = [];
          break;
        case '/dashboard/traffic':
          this.activeMenu = 'traffic';
          this.openKeys = [];
          break;
        case '/dashboard/login-record':
          this.activeMenu = 'login-record';
          this.openKeys = [];
          break;
        case '/dashboard/flow-record':
          this.activeMenu = 'flow-record';
          this.openKeys = [];
          break;
        // // 购买相关路由
        // case '/purchase/buy':
        //   this.activeMenu = 'purchase';
        //   this.openKeys = [];
        //   break;
        // // 静态住宅菜单相关路由
        // case '/staticnux/index':
        //   this.activeMenu = 'staticnux';
        //   this.openKeys = [];
        //   break;
        // case '/staticnux/purchase':
        //   this.activeMenu = 'staticnux-purchase';
        //   this.openKeys = [];
        //   break;
        // case '/staticnux/broadcast-purchase':
        //   this.activeMenu = 'staticnux-broadcast-purchase';
        //   this.openKeys = [];
        //   break;
        // 工具相关路由
        case '/utiltools/qrcode':
          this.activeMenu = 'utiltools-qrcode';
          this.openKeys = [];
          break;
        case '/utiltools/proxy-tester':
          this.activeMenu = 'utiltools-proxy-tester';
          this.openKeys = [];
          break;
        // API文档相关路由
        // case '/api-docs/dynamic':
        //   this.activeMenu = 'api-docs-dynamic';
        //   this.openKeys = [];
        //   break;
        // case '/api-docs/static':
        //   this.activeMenu = 'api-docs-static';
        //   this.openKeys = [];
        //   break;
        // 用户设置相关路由
        case '/user/settings':
          this.activeMenu = 'settings';
          this.openKeys = [];
          break;
        default:
          this.activeMenu = 'base';
          this.openKeys = [];
      }
    },
    
    // 检查登录状态
    checkLoginStatus() {
      const token = localStorage.getItem('Token') || localStorage.getItem('Authorization');
      const userName = localStorage.getItem('userName');
      this.isLoggedIn = !!token;
      this.userName = userName || '用户';
    },
    
    // 个人资料
    handleUserProfile() {
      // 可以跳转到个人资料页面
      console.log('查看个人资料');
    },
    
    // 账户设置
    handleSettings() {
      // 可以跳转到个人设置页面
      this.$router.push('/user/settings');
    },
    
    // 退出登录
    handleLogout() {
      // 清除localStorage中的登录信息
      localStorage.removeItem('Token');
      localStorage.removeItem('Authorization');
      localStorage.removeItem('userName');
      localStorage.removeItem('userId');
      localStorage.removeItem('subNumber');
      
      // 更新登录状态
      this.isLoggedIn = false;
      this.userName = '';
      
      // 跳转到登录页面
      this.$router.push('/login');
      
      // 显示退出成功提示
      this.$message.success('退出登录成功');
    },
    
    // 处理语言切换
    handleLanguageChange({ key }) {
      this.currentLanguage = this.languageMap[key];
      // 更新语言代码，用于传递给子组件
      this.languageCode = key === 'zh-CN' ? 'zh' : 'en';
      // 这里可以添加实际的语言切换逻辑，比如调用i18n插件的方法
      console.log('切换语言为:', key, '语言代码:', this.languageCode);
    },
    
    // 获取客服联系方式
    getCommentsDataList() {
      // 更新userId，确保获取最新的用户ID
      this.userId = localStorage.getItem('userId') || '';
      this.$request.get("/contact/selectAgentContact?userId=" + this.userId).then((res) => {
        if (res.data.code === 200) {
          this.FormatList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    
    // 客服弹窗
    Kefu() {
      this.visible = true;
      this.getCommentsDataList();
    }
  }
};
</script>

<style scoped>
/* 重置和基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* 全局布局样式 - 确保不溢出，无滚动条 */
.main-layout {
  min-height: 100vh;
  background: #f0f2f5;
  overflow: hidden; /* 防止整体溢出 */
  display: flex;
  flex-direction: column;
}

/* Logo样式优化 - 简化设计 */
.logo {
  height: 55px;
  margin-right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 菜单容器 - 顶部导航样式 */
.ant-menu {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: visible !important;
  width: auto !important;
}

/* 顶部导航栏样式优化 - 固定高度，深色主题 */
.main-layout-header {
  background: #1a1f35 !important;
  padding: 0 24px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
  height: 64px;
  border-bottom: 1px solid #262c40;
  overflow: visible;
  flex-shrink: 0;
}

/* 主内容区域 - 固定布局，无溢出 */
.ant-layout-content {
  background: #f0f2f5 !important;
  min-height: calc(100vh - 64px);
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 右侧导航样式 - 现代化布局，增强用户体验 */
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: visible;
  z-index: 11;
}

/* 语言切换样式 */
.language-switch {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 22px;
  cursor: pointer;
  /* background: rgba(255, 255, 255, 0.1); */
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  transition: all 0.2s ease;
}

.language-switch:hover {
  /* background: rgba(255, 255, 255, 0.2); */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); */
}

/* 语言文本样式 */
.language-text {
  font-size: 14px;
  font-weight: 550;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
}

/* 用户信息样式 - 简约设计 */
.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 22px;
  cursor: pointer;
  /* background: rgba(255, 255, 255, 0.1); */
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  transition: all 0.2s ease;
}

.user-info:hover {
  /* background: rgba(255, 255, 255, 0.2); */
  transform: none;
}

.user-info:active {
  transform: none;
  background: rgba(255, 255, 255, 0.15);
}

/* 用户名样式 - 简约显示 */
.user-info .username {
  font-size: 14px;
  font-weight: 550;
  color: rgba(255, 255, 255, 0.9);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.user-info:hover .username {
  color: white;
}

/* 头像样式 - 简约设计 */
.ant-avatar {
  flex-shrink: 0;
  transition: none;
  border: 2px solid transparent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.user-info:hover .ant-avatar {
  border-color: transparent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transform: none;
}

/* 下拉箭头样式 */
.user-info .anticon-down {
  transition: none;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.user-info:hover .anticon-down {
  color: white;
  transform: none;
}

/* 菜单子项下拉箭头样式 */
.ant-menu-submenu-title .ant-menu-submenu-arrow {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 12px !important;
}

.ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
  color: white !important;
}

/* 下拉菜单样式优化 */
.ant-dropdown-menu,
.ant-menu-sub {
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  background: linear-gradient(135deg, #1a1f35 0%, #202742 100%) !important;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

/* 下拉菜单项样式 */
.ant-dropdown-menu-item,
.ant-menu-sub .ant-menu-item {
  padding: 12px 24px !important;
  height: auto !important;
  line-height: 22px !important;
  transition: all 0.3s ease !important;
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.9) !important;
  background: transparent !important;
  border-radius: 8px !important;
  margin: 6px 8px !important;
}

/* 选中菜单项样式 */
.ant-dropdown-menu-item-selected,
.ant-menu-sub .ant-menu-item-selected {
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.3) 0%, rgba(9, 109, 217, 0.3) 100%) !important;
  color: white !important;
  font-weight: 500 !important;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4) !important;
}

.ant-dropdown-menu-item:hover,
.ant-menu-sub .ant-menu-item:hover {
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.2) 0%, rgba(9, 109, 217, 0.2) 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

/* 下拉菜单项图标样式 */
.ant-dropdown-menu-item .anticon,
.ant-menu-sub .ant-menu-item .anticon {
  font-size: 16px !important;
  margin-right: 12px !important;
  transition: all 0.3s ease;
  color: rgba(24, 144, 255, 0.8) !important;
}

.ant-dropdown-menu-item:hover .anticon,
.ant-menu-sub .ant-menu-item:hover .anticon {
  color: #1890ff !important;
  transform: scale(1.2) rotate(5deg);
}

/* 下拉菜单分割线样式 */
.ant-dropdown-menu-divider,
.ant-menu-sub .ant-menu-divider {
  margin: 6px 12px !important;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%) !important;
  height: 1px !important;
}

/* 内容区域样式优化 - 固定高度，内部滚动 */
.main-layout-content {
  margin: 16px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0; /* 允许内容区域收缩 */
}

/* 内容区域滚动条样式 */
.main-layout-content::-webkit-scrollbar {
  width: 6px;
}

.main-layout-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.main-layout-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.main-layout-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 页脚样式优化 - 固定高度，无溢出 */
.main-layout-footer {
  text-align: center;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 12px 0;
  margin: 0 16px 16px;
  color: #666;
  font-size: 12px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;
  overflow: hidden;
}

/* 右侧主内容区域的布局 */
.main-layout > .ant-layout {
  width: 100%;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #0a0a0a;
}

/* 响应式设计优化 - 适配小屏幕 */
@media (max-width: 768px) {
  .main-layout-content {
    margin: 12px;
    padding: 16px;
    border-radius: 6px;
  }
  
  .header-right {
    gap: 4px;
  }
  
  .user-info {
    gap: 6px;
    padding: 4px 8px;
  }
  
  .user-info .username {
    font-size: 12px;
    max-width: 80px;
  }
  
  .main-layout-footer {
    margin: 0 12px 12px;
    padding: 8px 0;
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .main-layout-content {
    margin: 8px;
    padding: 12px;
  }
  
  .main-layout-footer {
    margin: 0 8px 8px;
  }
}

.contact-link {
  color: #1890ff !important;
  text-decoration: none;
  transition: color 0.3s;
}

.contact-link:hover {
  color: #40a9ff !important;
  text-decoration: underline;
}
</style>
